exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-status{position:relative;display:inline-block}.paid{background-color:#669d31;bottom:4px}.advancePaymentPaid,.paid{padding:5px;display:inline-block;position:absolute}.advancePaymentPaid{background-color:#ec9a29;top:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7853e76","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/agreement/List.vue
// module id = 664
// module chunks = 0